/*
 Generated by typeshare 1.7.0
*/

export enum Automation {
	Caroline = "Caroline",
	Hubble = "Hubble",
	Support = "Support",
}

export type ApprovalKind = 
	| { kind: "Manager", inner?: undefined }
	| { kind: "Dynamic", inner?: undefined }
	| { kind: "User", inner?: {
	id: number;
}};

export interface ConfigApprovals {
	steps: ApprovalKind[];
}

export interface ConfigAutomation {
	api_key: string;
}

export interface ConfigCaroline {
	azure_chat_url: string;
	azure_chat_key: string;
	azure_chat_deployment: string;
	azure_chat_api_version: string;
	azure_chat_embedding_deployment: string;
	azure_search_url: string;
	azure_search_key: string;
	azure_search_index: string;
	azure_indexer_name: string;
	azure_indexer_api_version: string;
	azure_dalle_deployment: string;
	azure_dalle_api_version: string;
	azure_container_url: string;
	azure_container_name: string;
	azure_container_sas_key: string;
	slack_app_secret: string;
	slack_user_token: string;
	slack_bot_token: string;
	slack_bot_id: string;
	slack_app_user_token: string;
	slack_channels_whitelist: string[];
	slack_channels_dalle: string[];
}

export interface ConfigCompanyPermissions {
	approved_ids: number[];
	restricted_ids: number[];
}

export interface ConfigClient {
	url: string;
	user: string;
	pass: string;
	domain: string;
}

export interface ConfigClientApiKey {
	url: string;
	api_key: string;
}

export interface ConfigEmail {
	user: string;
	pass: string;
	domain: string;
	sender: string;
	base_url: string;
	admin_email: string;
}

export interface ConfigGroups {
	primary: string[];
	offboard: string[];
}

export interface ConfigHooksVom {
	verification_token: string;
	offboarding_secret: string;
	onboarding_secret: string;
	change_secret: string;
}

export interface ConfigJiraDetails {
	directory_id: number;
	role_read: string;
	role_write: string;
}

export interface ConfigJiraAccounts {
	sdop_pass: string;
	sdop_user: string;
	vcdm_pass: string;
	vcdm_user: string;
}

export interface ConfigLink {
	name: string;
	url: string;
}

export interface ConfigMimDetails {
	owner_id: string;
	company_id: string;
}

export interface ConfigMimGroup {
	id: string;
}

export interface ConfigMultipleMimGroups {
	read_only_group: string;
	licensed_group: string;
}

export interface ConfigPolarisDetails {
	organization_id: string;
}

export interface ConfigSchedule {
	interval_seconds: number;
}

export interface ConfigSimpleClient {
	url: string;
}

export interface ConfigTableauDetails {
	pat_name: string;
	pat_secret: string;
	pat_site_content_url: string;
	pat_expiration_date?: string;
	onboarding_group: string;
}

export interface ConfigEntraClient {
	login_url: string;
	api_url: string;
	client_id: string;
	tenant_id: string;
	scope: string;
	client_secret: string;
	grant_type: string;
}

export interface ConfigTableauEntraGroups {
	creator_group: string;
	viewer_group: string;
	explorer_group: string;
}

export interface ConfigToolLinks {
	main: string;
}

export interface ConfigToolPricing {
	desc: string;
}

export interface ConfigTool {
	avatar: string;
	display_name: string;
	short_desc: string;
	long_desc: string;
	links: ConfigToolLinks;
	pricing: ConfigToolPricing;
	contract_id?: number;
}

export interface ConfigItem {
	approvals?: ConfigApprovals;
	automation?: ConfigAutomation;
	caroline?: ConfigCaroline;
	company_permissions?: ConfigCompanyPermissions;
	client?: ConfigClient;
	client_api_key?: ConfigClientApiKey;
	email?: ConfigEmail;
	groups?: ConfigGroups;
	groups_jsm?: ConfigGroups;
	hooks_vom?: ConfigHooksVom;
	jira_details?: ConfigJiraDetails;
	jira_accounts?: ConfigJiraAccounts;
	links?: ConfigLink[];
	mim_details?: ConfigMimDetails;
	mim_group?: ConfigMimGroup;
	multiple_mim_groups?: ConfigMultipleMimGroups;
	polaris_details?: ConfigPolarisDetails;
	schedule?: ConfigSchedule;
	simple_client?: ConfigSimpleClient;
	tableau_details?: ConfigTableauDetails;
	entra_client?: ConfigEntraClient;
	tableau_entra_groups?: ConfigTableauEntraGroups;
	tool?: ConfigTool;
}

export interface AutomationConfig {
	kind: Automation;
	item: ConfigItem;
}

export interface CarolineMetrics {
	conv_count: string;
	avg_input: string;
	med_input: string;
	max_input: string;
	min_input: string;
	avg_output: string;
	med_output: string;
	max_output: string;
	min_output: string;
	positive_feedback: string;
	negative_feedback: string;
}

export interface CatalogItem {
	id: string;
	info: ConfigTool;
	contract_id?: number;
	mim_group_id?: string;
	company_permissions?: ConfigCompanyPermissions;
	approvals?: ConfigApprovals;
}

export interface Contract {
	id: number;
	name: string;
	partner: string;
	tags?: string[];
	owner: string;
	department: string;
	expiration_date?: string;
	pricing: string;
	short_desc: string;
	long_desc: string;
	how_to_order: string;
	avatar: string;
}

export type CollectionKind = 
	| { kind: "BigQueryMim", inner: {
	credentials: string;
	project_id: string;
	project_alias?: string;
	owner_role: string;
	allow_write_access: boolean;
	fallback_owner?: number;
}};

export interface CollectionInfo {
	display_name: string;
	short_desc: string;
	long_desc: string;
	avatar: string;
}

export interface Collection {
	id: string;
	kind: CollectionKind;
	info: CollectionInfo;
}

export interface DatasetListItem {
	id: string;
}

export enum EmployeeStatus {
	PERMANENT = "PERMANENT",
	TEMPORARY = "TEMPORARY",
	INTERNSHIP = "INTERNSHIP",
	SUMMER_INTERN = "SUMMER_INTERN",
	RESIGNED = "RESIGNED",
	ON_LEAVE = "ON_LEAVE",
}

export enum EmployeeType {
	VISMA_EMPLOYEE = "VISMA_EMPLOYEE",
	EXTERNAL_CONSULTANT = "EXTERNAL_CONSULTANT",
	INDEPENDENT_CONTRACTOR = "INDEPENDENT_CONTRACTOR",
}

export interface WorkingForLegalUnit {
	id: number;
	name: string;
}

export interface EmployeeDetails {
	name: string;
	id: number;
	firstName: string;
	lastName: string;
	username: string;
	email: string;
	status: EmployeeStatus;
	leavingDate?: string;
	employeeType: EmployeeType;
	workingForLegalUnit?: WorkingForLegalUnit;
	managerEmail?: string;
}

export interface User {
	employee: EmployeeDetails;
	vc_id?: string;
}

export interface DatasetMembership {
	owner?: User;
	has_read: boolean;
	has_write: boolean;
	can_read: boolean;
	can_write: boolean;
}

export interface DatasetAccessActions {
	grant_read: boolean;
	grant_write: boolean;
	revoke_read: boolean;
	revoke_write: boolean;
}

export interface BlackDuckProjectGroup {
	id?: string;
	name: string;
	depth: number;
}

export enum SupportIssueStatus {
	Done = "Done",
	Cancelled = "Cancelled",
	Unresolved = "Unresolved",
}

export interface SupportTicketState {
	issueId: number;
	taskStatus: SupportIssueStatus;
	issueResolution: string;
}

export interface CreateSupportTicketMetaOffering {
	key: string;
	name: string;
}

export interface CreateSupportTicketMetaRouting {
	description: string;
	jiraProject: number;
	jiraRequestType: string;
	key: string;
	name: string;
	url?: string;
}

export interface CreateSupportTicketMetaService {
	key: string;
	name: string;
	team: string;
}

export interface CreateSupportTicketMeta {
	catalogItem?: string;
	offering: CreateSupportTicketMetaOffering;
	routings: CreateSupportTicketMetaRouting[];
	service: CreateSupportTicketMetaService;
}

export interface SupportTicket {
	issueId: number;
	issueKey: string;
}

export interface CarolineSupportTicket {
	issueUrl: string;
}

export interface SupportDetails {
	service: CreateSupportTicketMetaService;
	routing: CreateSupportTicketMetaRouting;
	offering: CreateSupportTicketMetaOffering;
}

export enum JiraProjectPermission {
	None = "None",
	Read = "Read",
	Write = "Write",
}

export interface JiraAvailableProject {
	id: string;
	name: string;
	max_permission: JiraProjectPermission;
	cur_permission: JiraProjectPermission;
}

export enum Ext {
	BlackDuck = "BlackDuck",
	CompleteControl = "CompleteControl",
	Confluence = "Confluence",
	Crowd = "Crowd",
	Email = "Email",
	Entra = "Entra",
	Github = "Github",
	Jira = "Jira",
	Lucid = "Lucid",
	Mim = "Mim",
	Mural = "Mural",
	Octopus = "Octopus",
	Polaris = "Polaris",
	SonarQube = "SonarQube",
	SonarQubeEnt = "SonarQubeEnt",
	Statuspage = "Statuspage",
	Tableau = "Tableau",
	Udemy = "Udemy",
	Vgpt = "Vgpt",
	Vom = "Vom",
	Zeplin = "Zeplin",
}

export interface ExtConfig {
	kind: Ext;
	item: ConfigItem;
}

export interface PolarisAttributes {
	automated?: boolean;
	"first-time"?: boolean;
	system?: boolean;
	name?: string;
	"organization-admin"?: boolean;
	email?: string;
	enabled?: boolean;
	username?: string;
	groupname?: string;
}

export interface PolarisLinks {
	self: string;
	related: string;
}

export interface PolarisResource {
	type: string;
	id: string;
}

export interface PolarisOrganization {
	links?: PolarisLinks;
	data: PolarisResource;
}

export interface PolarisGroups {
	data: PolarisResource[];
}

export interface PolarisRelationships {
	organization: PolarisOrganization;
	groups?: PolarisGroups;
}

export interface PolarisObject {
	type: string;
	id?: string;
	attributes: PolarisAttributes;
	relationships: PolarisRelationships;
}

export interface TableauOwner {
	id: string;
}

export interface TableauProject {
	owner: TableauOwner;
	id: string;
	name: string;
}

export interface Employee {
	id: number;
	name?: string;
	firstName?: string;
	lastName?: string;
	username?: string;
	email?: string;
	status: EmployeeStatus;
	leavingDate?: string;
	employeeType: EmployeeType;
	workingForLegalUnit?: WorkingForLegalUnit;
	managerEmail?: string;
}

export interface LegalUnit {
	id: number;
	name: string;
}

export interface VomEmployee {
	id: number;
	name: string;
	email: string;
}

export enum HookKind {
	Vom = "Vom",
}

export interface HooksConfig {
	kind: HookKind;
	item: ConfigItem;
}

export enum ScheduleKind {
	CarolineIndex = "CarolineIndex",
	LoadContracts = "LoadContracts",
	RetryEmployeeOffboardings = "RetryEmployeeOffboardings",
	SyncUsers = "SyncUsers",
}

export interface ScheduleConfig {
	kind: ScheduleKind;
	item: ConfigItem;
}

export type TaskKind = 
	| { kind: "ToolAccess", inner: {
	kind: AccessKind;
	tool: Tool;
	target: number;
	note?: string;
}}
	| { kind: "CatalogAccess", inner: {
	kind: AccessKind;
	catalog_id: string;
	catalog_name: string;
	target: number;
	note?: string;
}}
	| { kind: "JiraProjectAccess", inner: {
	target: number;
	project_id: string;
	project_name: string;
	permission: JiraProjectPermission;
	note?: string;
}}
	| { kind: "BlackDuckProjectGroupAccess", inner: {
	target: number;
	project_group_id: string;
	project_group_name: string;
	note?: string;
}}
	| { kind: "PolarisGroupAccess", inner: {
	target: number;
	group_id: string;
	group_name: string;
	note?: string;
}}
	| { kind: "TableauSiteRoleChange", inner: {
	target: number;
	role: TableauSiteRole;
	note?: string;
}}
	| { kind: "TableauProjectRoleChange", inner: {
	target: number;
	project_id: string;
	project_name: string;
	role: TableauProjectRole;
	note?: string;
}}
	| { kind: "DatasetAccess", inner: {
	collection_id: string;
	collection_name: string;
	dataset_id: string;
	actions: DatasetAccessActions;
	target: number;
	note?: string;
}}
	| { kind: "EmployeeOffboarding", inner: {
	employee: EmployeeDetails;
	context: Record<Tool, boolean>;
	catalog_context?: Record<string, OffboardedCatalogContext>;
	custom_context?: Record<string, boolean>;
}}
	| { kind: "Support", inner: {
	details: SupportDetails;
	resource: Resource;
	target: number;
	note?: string;
	ticket?: SupportTicket;
	ticket_state?: SupportTicketState;
}}
	| { kind: "CarolineIndex", inner?: undefined }
	| { kind: "LoadContracts", inner?: undefined }
	| { kind: "RetryEmployeeOffboardings", inner?: undefined }
	| { kind: "SyncUsers", inner?: undefined };

export type TaskStatus = 
	| { kind: "Idle", inner?: undefined }
	| { kind: "Running", inner?: undefined }
	| { kind: "Paused", inner: {
	reason: PauseReason;
}}
	| { kind: "Error", inner?: undefined }
	| { kind: "Done", inner?: undefined }
	| { kind: "Cancelled", inner: {
	reason: CancelReason;
}};

export type TaskParent = 
	| { kind: "User", inner: {
	id: number;
}}
	| { kind: "Schedule", inner: {
	kind: ScheduleKind;
}}
	| { kind: "VomHook", inner: {
	subscription_id: string;
	message_id: string;
	notification_id: string;
	event_type: VomEvent;
}};

export type ApprovalStatus = 
	| { kind: "Idle", inner?: undefined }
	| { kind: "Notified", inner: {
	history: SentTo[];
}}
	| { kind: "Approved", inner: {
	ts: string;
	user_id: number;
	note?: string;
	original_approver?: number;
}}
	| { kind: "AutoApproved", inner: {
	ts: string;
	user_id: number;
	reason: AutoApprovedReason;
}}
	| { kind: "Denied", inner: {
	ts: string;
	user_id: number;
	reason?: string;
	original_approver?: number;
}};

export interface Approval {
	kind: ApprovalKind;
	status: ApprovalStatus;
}

export interface Task {
	id: string;
	kind: TaskKind;
	status: TaskStatus;
	parent: TaskParent;
	created: string;
	updated?: string;
	approvals?: Approval[];
}

export interface OffboardedCatalogContext {
	is_offboarded: boolean;
	catalog_name: string;
}

export interface SentTo {
	ts: string;
	sent_to: string;
}

export enum Tool {
	BlackDuck = "BlackDuck",
	Confluence = "Confluence",
	Jira = "Jira",
	JiraServiceManagement = "JiraServiceManagement",
	Lucid = "Lucid",
	Mural = "Mural",
	Octopus = "Octopus",
	Polaris = "Polaris",
	SonarQube = "SonarQube",
	SonarQubeEnt = "SonarQubeEnt",
	Tableau = "Tableau",
	Udemy = "Udemy",
	Zeplin = "Zeplin",
}

export interface ToolConfig {
	kind: Tool;
	item: ConfigItem;
}

export interface BoardingStatus {
	value: boolean;
	task_id?: string;
}

export enum CollectionKindDiscriminants {
	BigQueryMim = "BigQueryMim",
}

export interface DisplayedCollection {
	id: string;
	kind: CollectionKindDiscriminants;
	info: CollectionInfo;
	allow_write_access: boolean;
}

export enum LogSearchKind {
	Custom = "Custom",
	Request = "Request",
	Task = "Task",
	User = "User",
}

export interface LogSearchParams {
	kind: LogSearchKind;
	value: string;
}

export enum TaskListKind {
	Active = "Active",
	Archived = "Archived",
	Error = "Error",
}

export enum TaskKindDiscriminants {
	ToolAccess = "ToolAccess",
	MimToolAccess = "MimToolAccess",
	JiraProjectAccess = "JiraProjectAccess",
	BlackDuckProjectGroupAccess = "BlackDuckProjectGroupAccess",
	PolarisGroupAccess = "PolarisGroupAccess",
	TableauSiteRoleChange = "TableauSiteRoleChange",
	TableauProjectRoleChange = "TableauProjectRoleChange",
	DatasetAccess = "DatasetAccess",
	EmployeeOffboarding = "EmployeeOffboarding",
	CarolineIndex = "CarolineIndex",
	SupportTicket = "SupportTicket",
	LoadContracts = "LoadContracts",
	RetryEmployeeOffboardings = "RetryEmployeeOffboardings",
	SyncUsers = "SyncUsers",
}

export interface ListTasksParams {
	list_kind: TaskListKind;
	task_kind?: TaskKindDiscriminants;
	task_subkind?: string;
}

export interface JiraAvailableProject {
	id: string;
	name: string;
	max_permission: JiraProjectPermission;
	cur_permission: JiraProjectPermission;
}

export interface BlackDuckProjectGroupMembership {
	is_member: boolean;
	task?: Task;
}

export enum TokenAccount {
	VCDM = "VCDM",
	SDOP = "SDOP",
}

export enum TableauProjectRole {
	None = "None",
	Viewer = "Viewer",
	Explorer = "Explorer",
	Publisher = "Publisher",
	Custom = "Custom",
}

export enum TableauSiteRole {
	Unlicensed = "Unlicensed",
	Viewer = "Viewer",
	Explorer = "Explorer",
	ExplorerCanPublish = "ExplorerCanPublish",
	Creator = "Creator",
	SiteAdministratorExplorer = "SiteAdministratorExplorer",
	SiteAdministratorCreator = "SiteAdministratorCreator",
}

export enum VomEvent {
	EmployeeOffboarding = "EmployeeOffboarding",
	EmployeeOnboarding = "EmployeeOnboarding",
	EmployeeChange = "EmployeeChange",
}

export enum Role {
	Administrator = "Administrator",
	Developer = "Developer",
	CatalogEditor = "CatalogEditor",
	Security = "Security",
}

export type CanLogin = 
	| { kind: "Yes", inner: {
	user_details: EmployeeDetails;
}}
	| { kind: "No", inner: {
	reason: LoginReason;
}};

export enum LoginReason {
	Inactive = "Inactive",
	ExternalConsultant = "ExternalConsultant",
	NonVismaInfrastructure = "NonVismaInfrastructure",
	NoVomData = "NoVomData",
}

export enum PauseReason {
	WaitingForApproval = "WaitingForApproval",
	WaitingForSupport = "WaitingForSupport",
}

export type CancelReason = 
	| { kind: "ApprovalDenied", inner?: undefined }
	| { kind: "ByUser", inner: {
	user_id: number;
	ts: string;
	reason?: string;
}}
	| { kind: "SupportTicketCancelled", inner?: undefined };

export enum AccessKind {
	On = "On",
	Off = "Off",
}

export enum AutoApprovedReason {
	ApproverIsParent = "ApproverIsParent",
	ApproverPreference = "ApproverPreference",
}

export enum ResourceDiscriminants {
	Catalog = "Catalog",
	Contract = "Contract",
	Tool = "Tool",
}

export type Resource = 
	| { kind: "Catalog", inner: {
	id: string;
	name: string;
}}
	| { kind: "Contract", inner: {
	id: string;
	name: string;
}}
	| { kind: "Tool", inner: {
	id: Tool;
}};

export type ApprovalParams = 
	| { kind: "Approved", inner: {
	note?: string;
}}
	| { kind: "Denied", inner: {
	reason?: string;
}};

export type InMsg = 
	| { kind: "Login", inner: {
	token: string;
}}
	| { kind: "ConfluenceBulkOffboarding", inner: {
	users: string[];
}}
	| { kind: "JiraBulkOffboarding", inner: {
	users: string[];
}}
	| { kind: "JiraBulkOnboarding", inner: {
	users: string[];
}}
	| { kind: "PolarisBulkOffboarding", inner: {
	users: string[];
}}
	| { kind: "MimBulkOnboarding", inner: {
	users: string[];
	group_id: string;
}};

export type OutMsg = 
	| { kind: "LoggedIn", inner?: undefined }
	| { kind: "Output", inner: {
	content: string;
}}
	| { kind: "Done", inner?: undefined };

